/**
 * 收费管理（chargeManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/chargeManagement/ 下列表页及 modules/ 弹窗
 * 术语：户账=Customer Account，账单=Bill，缴费=Payment，充值=Recharge，
 *       欠费=Arrears，余额=Balance，销账=Write-off，对账=Reconciliation，用水户=Customer
 */
export default {
  // 通用词（与 en-US.js 保持一致，模块内自包含）
  '查询': 'Query',
  '重置': 'Reset',
  '删除': 'Delete',
  '详情': 'Details',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '已选择 {count} 项': '{count} items selected',
  '操作': 'Action',
  '创建时间': 'Created At',
  '备注': 'Remark',
  '关闭': 'Close',
  // 列表页公共
  '导出': 'Export',
  '刷新': 'Refresh',
  '展开': 'Expand',
  '收起': 'Collapse',
  '折叠': 'Collapse',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '区域名称': 'Area Name',
  '请输入区域名称': 'Please enter area name',
  '自定义列': 'Custom Columns',
  '未知': 'Unknown',
  '正常': 'Normal',
  '异常': 'Abnormal',
  '更新时间': 'Updated At',
  '元': 'CNY',
  // 用户余额/告警列表
  '用户余额': 'Customer Balance',
  '余额告警': 'Balance Alarm',
  '告警类型': 'Alarm Type',
  '请选择告警类型': 'Select alarm type',
  '余额达到报警金额': 'Balance reached alarm amount',
  '余额达到透支金额': 'Balance reached overdraft amount',
  '自定义余额范围': 'Custom balance range',
  '用户余额范围': 'Customer Balance Range',
  '用户余额起始值不能大于终止值': 'Balance range start cannot be greater than end',
  '充值次数': 'Recharge Count',
  '当前价格信息': 'Current Price Info',
  '价格名称': 'Price Name',
  '请选择价格名称': 'Please select price name',
  '当前余额(元)': 'Current Balance (CNY)',
  '累计用量(m³)': 'Cumulative Usage (m³)',
  '阀门状态': 'Valve Status',
  '请选择阀门状态': 'Select valve status',
  '批量添加命令(按区域)': 'Batch Add Commands (By Area)',
  '批量添加命令(按表号)': 'Batch Add Commands (By Meter No.)',
  '批量添加命令(按Excel表号)': 'Batch Add Commands (By Excel Meter No.)',
  '总预存金额：': 'Total Prepaid:',
  '总欠费金额：': 'Total Arrears:',
  '命令队列': 'Command Queue',
  '命令下发': 'Send Command',
  '批量命令下发': 'Batch Command Dispatch',
  '批量命令命令下发': 'Batch Command Dispatch',
  '选择批量下发表类型': 'Select Meter Type for Batch Dispatch',
  '请选择表类型': 'Select meter type',
  '请先选择批量下发命令的表类型': 'Please select the meter type for batch command first',
  '请先选择需要批量发送命令的表号': 'Please select the meter No. to send commands first',
  '选择批量下发的表类型不一致不能操作，请重新选择同一表类型的表具': 'Batch sending requires the same meter type. Please re-select meters of the same type',
  '请设置url.list属性!': 'Please set the url.list property!',
  // 用户/表基本信息
  '用户编号': 'Customer No.',
  '请输入用户编号': 'Please enter customer No.',
  '请输入用户编号模糊查询': 'Enter customer No. to search',
  '用户姓名': 'Customer Name',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户姓名模糊查询': 'Enter customer name to search',
  '用户名': 'Username',
  '用户id': 'Customer ID',
  '请输入用户id': 'Please enter customer ID',
  '用户地址': 'Customer Address',
  '请输入用户地址模糊查询': 'Enter customer address to search',
  '手机号码': 'Mobile Phone',
  '表编号': 'Meter No.',
  '请输入表编号': 'Please enter meter No.',
  '请输入表编号模糊查询': 'Enter meter No. to search',
  '表类型': 'Meter Type',
  '表安装地址': 'Meter Installation Address',
  // 户账变动记录
  '账户实时表变动前金额': 'Real-time Account Amount Before Change',
  '请输入账户实时表变动前金额 单位分': 'Please enter amount before change (in cents)',
  '账户变动后剩余金额': 'Remaining Amount After Change',
  '请输入账户变动后剩余金额 单位分': 'Please enter remaining amount after change (in cents)',
  '用户账户变动前用户累积量': 'Customer Cumulative Usage Before Change',
  '请输入用户账户变动前用户累积量': 'Please enter customer cumulative usage before change',
  '用户变动后用水累计量': 'Customer Cumulative Usage After Change',
  '请输入用户变动后用水累计量': 'Please enter customer cumulative usage after change',
  '账户变动金额': 'Account Change Amount',
  '用户账户变动金额': 'Customer Account Change Amount',
  '请输入用户账户变动金额': 'Please enter customer account change amount',
  '金额变动类型': 'Amount Change Type',
  '用户金额变动类型': 'Customer Amount Change Type',
  '请输入用户金额变动类型 1开户 2充值 3计费 4补水 5退水 6换表': 'Please enter amount change type 1.Open 2.Recharge 3.Billing 4.Water Supplement 5.Refund 6.Meter Replacement',
  '用户变动备注': 'Change Remarks',
  '请输入用户变动备注': 'Please enter change remarks',
  '用户变动备注备用1': 'Change Remarks Backup 1',
  '请输入用户变动备注备用1': 'Please enter change remarks backup 1',
  '请输入备注信息': 'Please enter remark',
  '创建操作员': 'Created By',
  '创建操作员代码': 'Creator Operator Code',
  // 账单
  '账单金额': 'Bill Amount',
  '账单日期': 'Bill Date',
  '请选择账单日期': 'Select bill date',
  '账单是否结账': 'Bill Settled',
  '请输入账单是否结账 0 未结账 1已结账': 'Please enter bill settled status 0.Unsettled 1.Settled',
  '用户账单Id': 'Customer Bill ID',
  '请输入用户账单Id': 'Please enter customer bill ID',
  '用户账单金额': 'Customer Bill Amount',
  '请输入用户账单金额': 'Please enter customer bill amount',
  '上期读数': 'Previous Reading',
  '请输入用户上期读数': 'Please enter customer previous reading',
  '用户上期读数': 'Customer Previous Reading',
  '本期抄表读数': 'Current Meter Reading',
  '请输入本期抄表读数': 'Please enter current meter reading',
  '上期抄表时间': 'Previous Meter Reading Time',
  '请选择上期抄表时间': 'Select previous meter reading time',
  '本期抄表时间': 'Current Period Meter Reading Time',
  '请选择本期抄表时间': 'Select current meter reading time',
  '本期用量': 'Current Usage',
  '请输入用户本期用量': 'Please enter customer current usage',
  '用户本期用量': 'Customer Current Usage',
  // 户账详情
  '报警金额(元)': 'Alarm Amount (CNY)',
  '透支金额(元)': 'Overdraft Amount (CNY)',
  '当前计费阶级': 'Current Billing Tier',
  '当前阶梯使用量(m³)': 'Current Tier Usage (m³)',
  '开始计费读数(m³)': 'Billing Start Reading (m³)',
  // 对账
  '营收对账详情列表': 'Revenue Reconciliation Details',
  '对账任务列表': 'Reconciliation Task List',
  '收费对账记录': 'Payment Reconciliation Record',
  '对账状态': 'Reconciliation Status',
  '请选择对账状态': 'Select reconciliation status',
  '交易设备': 'Transaction Device',
  '请选择交易设备': 'Select transaction device',
  '交易流水号': 'Transaction Serial No.',
  '请输入交易流水号': 'Please enter transaction serial No.',
  '订单编号': 'Order No.',
  '请输入订单编号': 'Please enter order No.',
  '商品订单号': 'Product Order No.',
  '交易起止时间': 'Transaction Start/End Time',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '交易时间': 'Transaction Time',
  '对账结果': 'Reconciliation Result',
  '对账时间': 'Reconciliation Time',
  '对账正常': 'Reconciliation Passed',
  '对账异常': 'Reconciliation Failed',
  '对账员': 'Reconciler',
  // 交易设备枚举（deviceTypeObj）
  '充值机': 'Recharge Machine',
  '支付宝': 'Alipay',
  '银行app': 'Bank App'
}
